import { useState } from "react";
import StudentFilter from "types/StudentFilter";
import { GradeLevelGroup } from "types/Student";
import { Accordion } from "./ui/Accordion";

interface SubjectTreeProps {
  gradeLevelGroups: GradeLevelGroup[];
  onSelect: (filter: StudentFilter) => void;
}

export function SubjectTree({ gradeLevelGroups, onSelect }: SubjectTreeProps) {
  const [selected, setSelected] = useState<StudentFilter>({});

  const selectGrade = (gradeLevel: string) => {
    const selection: StudentFilter = { gradeLevel };
    setSelected(selection);
    onSelect(selection);
  };

  const selectSubject = (gradeLevel: string, subject: string) => {
    const selection: StudentFilter = { gradeLevel, subject };
    setSelected(selection);
    onSelect(selection);
  };

  return (
    <div className="mb-4">
      <h2 className="text-xs lg:text-sm font-bold uppercase text-gray-500 mb-2">Subjects</h2>
      <Accordion
        items={gradeLevelGroups.map((grade) => ({
          id: grade.gradeLevel,
          title: grade.gradeLevel,
          onTitleClick: () => selectGrade(grade.gradeLevel),
          content: (
            <ul className="space-y-1">
              {grade.subjects.map((subject) => (
                <li
                  key={subject}
                  onClick={() => selectSubject(grade.gradeLevel, subject)}
                  className={`cursor-pointer hover:bg-gray-100 p-1 rounded text-xs lg:text-sm ${
                    selected.gradeLevel === grade.gradeLevel &&
                    selected.subject === subject
                      ? "bg-blue-100 text-blue-700 font-semibold"
                      : ""
                  }`}
                >
                  {subject}
                </li>
              ))}
            </ul>
          ),
        }))}
      />
    </div>
  );
}
